import { createPromiseAction } from 'redux-saga-promise-actions';
import { createAction } from 'typesafe-actions';
import { PaymentTrip } from 'store/types/payments';
import {
  TicketCreditInformationOld,
  TicketContent,
  RebookingTypeId,
  GetRebookingPassengerBuyType,
  CheckoutResponse,
  CheckoutPayload,
} from 'store/types';

export const createRebooking = createPromiseAction(
  'CREATE_REBOOKING',
  'CREATE_REBOOKING_SUCESS',
  'CREATE_REBOOKING_FAILURE',
)<{ tickets: string[] | any }, RebookingTypeId, undefined>();

export const getCreditBookingInformation = createPromiseAction(
  'GET_CREDIT_BOOKING',
  'GET_CREDIT_BOOKING_SUCESS',
  'GET_CREDIT_BOOKING_FAILURE',
)<{ bookingId: string | null; tickets: any; type?: any }, TicketCreditInformationOld, undefined>();

export const setTicketCreditOld = createAction('SET_TICKET_CREDIT_OLD', (ticket: TicketContent[] | any) => ({
  ticket,
}))<{ ticket: TicketContent[] }>();

export const setTripOld = createAction('SET_TRIP_OLD', (tripOld: PaymentTrip | any) => ({
  tripOld,
}))<{ tripOld: PaymentTrip }>();

export const getRebookingBuyerPassenger = createPromiseAction(
  'GET_REBOOKING_BUYER_PASSENGER',
  'GET_REBOOKING_BUYER_PASSENGER_SUCESS',
  'GET_REBOOKING_BUYER_PASSENGER_FAILURE',
)<{ RebookingId: string }, GetRebookingPassengerBuyType, undefined>();

export const makePaymentRebooking = createPromiseAction(
  'MAKE_PAYMENT_REBOOKING_REQUEST',
  'MAKE_PAYMENT_REBOOKING_SUCCEEDED',
  'MAKE_PAYMENT_REBOOKING_FAILURE',
)<CheckoutPayload, CheckoutResponse, undefined>();
